<script setup lang="ts">
const { t } = useTexts();
const { isUserV2Enabled } = useFeatureFlagsJson();

useSeo({
  title: t('account.history.poker.title'),
});
</script>

<template>
  <UserV2ScreenPokerHistory v-if="isUserV2Enabled" />
  <UserAccountPageLayout
    v-else
    on-back="user-history"
    :title="$t('account.history.poker.title')"
  >
    <div :class="$style.walletTransactions">
      <div class="alert alert-warning">
        {{ $t('account_menu.soon') }}
      </div>
      <!-- <UserWalletTransactions /> -->
    </div>
  </UserAccountPageLayout>
</template>

<style module lang="scss">
.walletTransactions {
  @apply w-full h-auto m-0 max-w-[792px];
}
</style>
